import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import {
    GoogleMap,
    useJsApiLoader,
    DrawingManager,
    Autocomplete,
    Rectangle,
} from "@react-google-maps/api";
import { Box, Skeleton } from "@mui/material";
import styles from "./style";
import { css } from "aphrodite";

const mapLibraries = ["drawing", "places", "geometry"];

export const DEFAULT_MAP_LAT_LNG = { lat: -3.745, lng: -38.523 };

const GeofenceRectangleArea = ({ bounds, zoom, clearClick, height }) => {
    const { isLoaded, error } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_NEXT_PUBLIC_GOOGLE_MAPS_API,
        libraries: mapLibraries,
        version: "3.64",
    });

    const [map, setMap] = useState();
    const [rectangleBounds, setRectangleBounds] = useState(bounds);

    // Ensure rectangleBounds are valid numbers
    const isValidBounds = (bounds) => {
        return (
            bounds &&
            !isNaN(bounds.north) &&
            !isNaN(bounds.south) &&
            !isNaN(bounds.east) &&
            !isNaN(bounds.west)
        );
    };

    useEffect(() => {
        if (isValidBounds(bounds)) {
            setRectangleBounds(bounds);
        } else {
            setRectangleBounds(null);
        }
    }, [bounds]);

    useEffect(() => {
        if (clearClick) {
            setRectangleBounds(null);
        }
    }, [clearClick]);

    useEffect(() => {
        if (map && !rectangleBounds) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    map?.setCenter(pos);
                    map?.setZoom(zoom);
                },
                () => {
                    map?.setCenter(DEFAULT_MAP_LAT_LNG);
                    map?.setZoom(2);
                }
            );
        }
    }, [map, rectangleBounds, zoom]);

    const rectangleRef = useRef();

    const onRectangleLoad = useCallback((rectangle) => {
        rectangleRef.current = rectangle;
    }, []);

    const onRectangleUnmount = useCallback(() => {
        rectangleRef.current = undefined;
    }, []);

    const [searchBox, setSearchBox] = useState();

    // if (error) {
    //     return <div className={css(styles.errorStyle)}> Map cannot be loaded right now, sorry. </div >;
    // }

    if (!isLoaded || error) {
        return <Skeleton variant="rectangular" animation="wave" height={500} />;
    }

    //console.log("key...",process.env.REACT_APP_NEXT_PUBLIC_GOOGLE_MAPS_API)

    return (
        <Box>
            <GoogleMap
                mapContainerStyle={{ width: "100%", height: height }}
                zoom={zoom}
                center={
                    rectangleBounds && Object.keys(rectangleBounds).length > 0
                        ? {
                              lat:
                                  (rectangleBounds.north +
                                      rectangleBounds.south) /
                                  2,
                              lng:
                                  (rectangleBounds.east +
                                      rectangleBounds.west) /
                                  2,
                          }
                        : DEFAULT_MAP_LAT_LNG
                }
                onLoad={(map) => {
                    setMap(map);
                }}
                options={{
                    mapTypeControl: false,
                    draggable: false,
                    scaleControl: false,
                    scrollwheel: false,
                    navigationControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    fullscreenControl: false,
                    clickableIcons: false,
                }}
            >
                <Rectangle
                    bounds={rectangleBounds}
                    //editable
                    //draggable
                    onLoad={onRectangleLoad}
                    onUnmount={onRectangleUnmount}
                    options={{
                        fillColor: `#009eee`,
                        //fillOpacity: 1,
                        strokeColor: "#009eee",
                        strokeWeight: 1,
                    }}
                />
            </GoogleMap>
        </Box>
    );
};

GeofenceRectangleArea.propTypes = {
    zoom: PropTypes.number,
    clearClick: PropTypes.number,
    bounds: PropTypes.object,
};

export default GeofenceRectangleArea;
